import script from "./QBottomPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./QBottomPanel.vue?vue&type=script&setup=true&lang=js"

import "./QBottomPanel.vue?vue&type=style&index=0&id=2d2a7677&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d2a7677"]])

export default __exports__